"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const Circle_1 = require("../Circle");
const Icon_1 = require("../Icon");
const IconContent = styled_1.default.div({
    flexShrink: 0,
    marginLeft: 8,
});
const SelectedIcon = (props) => {
    return ((0, jsx_runtime_1.jsx)(IconContent, { children: props.selected && ((0, jsx_runtime_1.jsx)(Circle_1.Circle, { backgroundColor: constants_1.Color.LIGHTER_GREEN, size: 16, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { color: constants_1.Color.GREEN, name: "CheckIcon", size: "sm" }) })) }));
};
exports.SelectedIcon = SelectedIcon;
